export const PROFILES = [
  {
    slug: "veiculos",
    index: "01",
    label: "Veículos",
    title: "Busca e apreensão de veículo",
    kicker: "Carro, moto, caminhonete financiados",
    short: "Parcelas em atraso, notificação do banco ou liminar de busca e apreensão do seu veículo.",
    heroLines: ["Seu carro em", "busca e apreensão?", "Ainda há caminho."],
    intro:
      "Quando o financiamento atrasa, o banco pode pedir a busca e apreensão do veículo com base na alienação fiduciária. Os prazos depois da apreensão são curtos — agir cedo faz toda a diferença para negociar e proteger o bem.",
    image: "/img/vehicle.webp",
    situations: [
      "Recebi notificação extrajudicial do banco ou da financeira",
      "Tenho parcelas em atraso e medo de perder o veículo",
      "Já existe ação de busca e apreensão contra mim",
      "Meu veículo já foi apreendido e preciso agir rápido",
    ],
    solutions: [
      { t: "Análise do contrato", d: "Revisamos o financiamento, os encargos cobrados e a regularidade da notificação e do processo." },
      { t: "Negociação com o banco", d: "Buscamos um acordo viável junto à instituição financeira, com condições compatíveis com a sua realidade." },
      { t: "Defesa no processo", d: "Atuação técnica na ação de busca e apreensão, observando cada prazo previsto em lei." },
      { t: "Acompanhamento até o fim", d: "Você é informado de cada etapa até a solução definitiva do caso." },
    ],
    alert:
      "Pelo Decreto-Lei 911/69, após a apreensão os prazos para pagamento e defesa são de poucos dias. Não espere a situação se agravar.",
    faqs: [
      { q: "O banco pode tomar meu carro sem aviso?", a: "O banco precisa comprovar a mora, normalmente por notificação. Por isso, se você recebeu uma carta ou notificação, esse é o momento ideal para buscar orientação." },
      { q: "Ainda dá para negociar depois da liminar?", a: "Em muitos casos, sim. A negociação pode acontecer em diferentes fases do processo — cada situação precisa ser analisada individualmente." },
      { q: "Preciso ir até o escritório?", a: "Não necessariamente. O primeiro contato e a análise inicial podem ser feitos pelo WhatsApp, com envio dos documentos." },
    ],
  },
  {
    slug: "agronegocio",
    index: "02",
    label: "Agronegócio",
    title: "Agronegócio e maquinário agrícola",
    kicker: "Produtores rurais e empresas do campo",
    short: "Tratores, colheitadeiras e implementos em busca e apreensão, execuções e ações monitórias de crédito rural.",
    heroLines: ["Quem produz", "merece defesa", "à altura da safra."],
    intro:
      "O produtor rural enfrenta riscos que não controla: clima, preço, mercado. Quando a dívida bancária aperta, máquinas, safra e patrimônio entram em jogo. Atuamos na negociação com os bancos e na defesa em busca e apreensão, execução de título extrajudicial e ação monitória.",
    image: "/img/agro.webp",
    situations: [
      "Trator, colheitadeira ou implemento em busca e apreensão",
      "Execução de cédula de crédito rural, CPR ou contrato bancário",
      "Ação monitória cobrando dívida do custeio ou investimento",
      "Safra frustrada e necessidade de renegociar o passivo bancário",
    ],
    solutions: [
      { t: "Diagnóstico do passivo rural", d: "Mapeamos contratos, garantias e processos para enxergar o cenário completo da dívida." },
      { t: "Negociação e reestruturação", d: "Conduzimos a negociação com as instituições financeiras buscando prazo e condições compatíveis com o ciclo produtivo." },
      { t: "Defesa em busca e apreensão", d: "Atuação para proteger o maquinário essencial à atividade rural." },
      { t: "Execução e monitória", d: "Defesa técnica nas ações de cobrança, com análise das particularidades do crédito rural." },
    ],
    alert:
      "No crédito rural há regras próprias, como a possibilidade de alongamento da dívida em determinadas hipóteses (Súmula 298 do STJ). Cada contrato precisa ser analisado.",
    faqs: [
      { q: "Atendem produtores de outros estados?", a: "Sim. Estamos no Rio de Janeiro e o atendimento pode ser feito de forma remota, com análise de documentos pelo WhatsApp." },
      { q: "Tenho mais de um processo com bancos diferentes. Vocês cuidam de tudo?", a: "Sim. Organizamos o passivo como um todo para que a estratégia de negociação e defesa seja coerente entre os casos." },
      { q: "A safra frustrada influencia na negociação?", a: "Pode influenciar. Frustração de safra e outras dificuldades do setor são pontos analisados na estratégia de cada caso." },
    ],
  },
  {
    slug: "maquinas-e-bens",
    index: "03",
    label: "Máquinas e bens",
    title: "Máquinas, equipamentos e outros bens",
    kicker: "Empresários, transportadores, autônomos",
    short: "Caminhões, frotas, máquinas pesadas e outros bens dados em alienação fiduciária.",
    heroLines: ["O bem que move", "o seu trabalho", "precisa ficar."],
    intro:
      "Caminhões, máquinas de obra, equipamentos industriais: quando o bem financiado é a ferramenta de trabalho, perdê-lo significa parar a operação. Negociamos com os bancos e atuamos na defesa contra a busca e apreensão de bens em alienação fiduciária.",
    image: "/img/machines.webp",
    situations: [
      "Caminhão ou frota com financiamento em atraso",
      "Máquina pesada ou equipamento industrial sob risco de apreensão",
      "Outros bens dados em garantia fiduciária ao banco",
      "Empresa com dificuldade de caixa e várias dívidas bancárias",
    ],
    solutions: [
      { t: "Análise das garantias", d: "Avaliamos o contrato, a alienação fiduciária e a regularidade da cobrança." },
      { t: "Negociação estratégica", d: "Buscamos acordo com a instituição financeira para preservar a continuidade do seu negócio." },
      { t: "Defesa processual", d: "Atuação técnica na ação de busca e apreensão e nos incidentes do processo." },
      { t: "Visão do negócio", d: "Estratégia pensada para a realidade da sua operação, não apenas para o processo." },
    ],
    alert:
      "Bens essenciais à atividade merecem atenção especial na estratégia. Quanto antes o caso for analisado, mais alternativas existem.",
    faqs: [
      { q: "Atendem pessoa jurídica?", a: "Sim. Atendemos pessoas físicas, empresas e profissionais autônomos que tenham bens em alienação fiduciária." },
      { q: "E se forem vários bens financiados?", a: "Analisamos todos os contratos em conjunto para definir prioridades e a melhor estratégia de negociação." },
      { q: "Como começo?", a: "Envie uma mensagem pelo WhatsApp ou preencha o formulário. Faremos uma análise inicial da sua situação." },
    ],
  },
  {
    slug: "execucao-e-monitoria",
    index: "04",
    label: "Execução e monitória",
    title: "Execução de título extrajudicial e ação monitória",
    kicker: "Cobranças judiciais de dívidas",
    short: "Citação em execução de título extrajudicial, bloqueio de contas, penhora de bens ou ação monitória.",
    heroLines: ["Foi citado", "em execução", "ou monitória?"],
    intro:
      "Contratos bancários, cédulas, notas promissórias e cheques podem gerar uma execução de título extrajudicial. Quando falta um título executivo, o credor pode usar a ação monitória. Nos dois casos há prazos para defesa e espaço para negociação — e cada dia conta.",
    image: "/img/documents.webp",
    situations: [
      "Fui citado em uma execução de título extrajudicial",
      "Minha conta foi bloqueada ou há penhora de bens",
      "Recebi citação em ação monitória",
      "Quero negociar a dívida antes que o processo avance",
    ],
    solutions: [
      { t: "Embargos à execução", d: "Defesa técnica contra a execução, com análise do título, dos valores e dos encargos cobrados." },
      { t: "Embargos monitórios", d: "Resposta na ação monitória questionando a dívida e os documentos apresentados pelo credor." },
      { t: "Bloqueios e penhoras", d: "Análise da legalidade de bloqueios de contas e penhoras, buscando proteger o que a lei permite." },
      { t: "Acordo com o credor", d: "Negociação com o banco ou credor em busca de uma solução definitiva e viável." },
    ],
    alert:
      "Em regra, o prazo para embargos à execução e embargos monitórios é de 15 dias úteis, conforme o Código de Processo Civil. Busque orientação assim que receber a citação.",
    faqs: [
      { q: "Qual a diferença entre execução e ação monitória?", a: "Na execução, o credor já tem um título executivo (como uma cédula de crédito). Na monitória, ele tem uma prova escrita da dívida, mas sem força de título executivo, e pede ao juiz que a reconheça." },
      { q: "Minha conta foi bloqueada. O que fazer?", a: "Existem valores que a lei protege, como salário e determinadas reservas. É importante analisar o bloqueio rapidamente para verificar o que pode ser questionado." },
      { q: "Ainda é possível fazer acordo?", a: "Sim, a negociação pode ocorrer em qualquer fase do processo. Uma defesa bem feita também fortalece a sua posição na negociação." },
    ],
  },
];

export const getProfile = (slug) => PROFILES.find((p) => p.slug === slug);
